import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

type TagProps = {
    children: ReactNode
    className?: string
}

export const Tag: FC<TagProps> = ({ children, className }): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-center rounded-[9px] border border-line bg-surface px-3 py-[7px]',
                'font-body text-[14px] leading-[1.4] text-ink',
                className
            )}
        >
            {children}
        </span>
    )
}
